// extracted by mini-css-extract-plugin
export default {"settingsContainer":"Settings_settingsContainer__7HdW+","topSettings":"Settings_topSettings__V1J9L","radius":"Settings_radius__bEl4D"};